module.exports = __webpack_public_path__ + "img/105.742b92af.png";